import PropTypes from "prop-types";
import React, {useEffect, useState} from "react";
import { a } from "react-router-dom";
import { multilanguage } from "redux-multilanguage";
import axios from "axios";
import {useTranslation} from "react-i18next";

const MobileNavMenu = ({ strings }) => {
  const [user, setUser] = useState(null);
  const { t, i18n } = useTranslation();

  const getProfile = () => {
    let query = 'https://api.therunningcollective.fr/api/protectedFront/profile'
    axios.post(query, null, {
      headers: {
        'Authorization': `Bearer ${JSON.parse(localStorage.getItem('trc-client-token')).token}`
      }
      ,}
    )
        .then((res) => {
          setUser(res.data)
        })
        .catch((err) => {
          console.log(err);
          localStorage.removeItem('trc-client-token');
        })
  };

  useEffect(() => {
    let token = JSON.parse(localStorage.getItem('trc-client-token'))
    if (token) {
      getProfile(token);

    }
  }, []);

  return (
    <nav className="offcanvas-navigation" id="offcanvas-navigation">
      <ul>
        <li className="menu-item-has-children">
          <a href={process.env.PUBLIC_URL + "/"}>{t('home')}</a>
        </li>
        <li className="menu-item-has-children">
          <a href={process.env.PUBLIC_URL + "/products?genders=Men&page=1"}>
            {" "}
            {t('men')}
          </a>
          <ul className="sub-menu">
            <li className="menu-item-has-children">
              <a href={process.env.PUBLIC_URL + "/products/shoes?genders=Men&page=1"}>
                {t('shoes')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/spikes?shopType=athletisme&page=1"}>
                    {t('spikes')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?genders=Men&page=1"}>
                    {t('road')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?genders=Men&shopType=trail&page=1"}>
                    {t('trail')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?category=Claquettes&page=1"}>
                    {t('thongs')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?genders=Men&page=1"}>
                    {t('allshoes')}
                  </a>
                </li>
              </ul>
            </li>
            <li className="menu-item-has-children">
              <a href={process.env.PUBLIC_URL + "/products/apparel?genders=Men&page=1"}>
                {t('apparel')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?genders=Men&category=Débardeurs&page=1"}>
                    {t('singlet')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?genders=Men&category=Tee-shirts&page=1"}>
                    {t('teeshirt')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?genders=Men&category=Vestes&page=1"}>
                    {t('hoodies')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?genders=Men&category=Cuissards&page=1"}>
                    {t('halftigh')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?genders=Men&category=Shorts&page=1"}>
                    {t('short')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?genders=Men&category=Collants&page=1"}>
                    {t('longtight')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?genders=Men&category=Equipe%20de%20France&page=1"}>
                    {t('frenchteam')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?genders=Men&page=1"}>
                    {t('allproducts')}
                  </a>
                </li>
              </ul>
            </li>
            <li className="menu-item-has-children">
              <a href={process.env.PUBLIC_URL + "/products/accessories?page=1"}>
                {t('accessories')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?category=Bonnets&page=1"}>
                    {t('hat')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?category=Chaussettes&page=1"}>
                    {t('socks')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?genders=Men&category=Gants&page=1"}>
                    {t('gloves')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/electronic?category=Montres%20GPS&page=1"}>
                    {t('gps')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/nutrition?page=1"}>
                    {t('food')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/electronic?page=1"}>
                    {t('electronic')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?category=Sac%20à%20dos&page=1"}>
                    {t('bag')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?page=1"}>
                    {t('allaccesories')}
                  </a>
                </li>
              </ul>
            </li>
            <li className="menu-item-has-children">
              <a href={process.env.PUBLIC_URL + "/products?genders=Men&page=1"}>
                {t('brands')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Men&brands=adidas&page=1"}>
                    adidas
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Men&brands=Asics&page=1"}>
                    Asics
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Men&brands=Hoka%20One%20One&page=1"}>
                    Hoka One One
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Men&brands=New%20Balance&page=1"}>
                    New Balance
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Men&brands=Nike&page=1"}>
                    Nike
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Men&brands=On%20Running&page=1"}>
                    On Running
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Men&brands=Puma&page=1"}>
                    Puma
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Men&brands=Saucony&page=1"}>
                    Saucony
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li className="menu-item-has-children">
          <a href={process.env.PUBLIC_URL + "/products?genders=Women&page=1"}>
            {" "}
            {t('women')}
          </a>
          <ul className="sub-menu">
            <li className="menu-item-has-children">
              <a href={process.env.PUBLIC_URL + "/products/shoes?genders=Women&page=1"}>
                {t('shoes')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/spikes?page=1"}>
                    {t('spikes')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?genders=Women&page=1"}>
                    {t('road')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?genders=Women&shopType=trail&page=1"}>
                    {t('trail')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?category=Claquettes&page=1"}>
                    {t('thongs')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?genders=Women&page=1"}>
                    {t('allshoes')}
                  </a>
                </li>
              </ul>
            </li>
            <li className="menu-item-has-children">
              <a href={process.env.PUBLIC_URL + "/products/apparel?genders=Women&page=1"}>
                {t('apparel')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?genders=Women&category=Brassières&page=1"}>
                    {t('bra')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?genders=Women&category=Débardeurs&page=1"}>
                    {t('singlet')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?genders=Women&category=Tee-shirts&page=1"}>
                    {t('teeshirt')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?genders=Women&category=Vestes&page=1"}>
                    {t('hoodies')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?genders=Women&category=Shorts&page=1"}>
                    {t('short')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?genders=Women&category=Collants&page=1"}>
                    {t('longtight')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?genders=Women&category=Equipe%20de%20France&page=1"}>
                    {t('frenchteam')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?genders=Women&page=1"}>
                    {t('allproducts')}
                  </a>
                </li>
              </ul>
            </li>
            <li className="menu-item-has-children">
              <a href={process.env.PUBLIC_URL + "/products/accessories?page=1"}>
                {t('accessories')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?category=Bonnets&page=1"}>
                    {t('hat')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?category=Chaussettes&page=1"}>
                    {t('socks')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?genders=Women&category=Gants&page=1"}>
                    {t('gloves')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/electronic?category=Montres%20GPS&page=1"}>
                    {t('gps')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/nutrition?page=1"}>
                    {t('food')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/electronic?page=1"}>
                    {t('electronic')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?category=Sac%20à%20dos&page=1"}>
                    {t('bag')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?page=1"}>
                    {t('allaccesories')}
                  </a>
                </li>
              </ul>
            </li>
            <li className="menu-item-has-children">
              <a href={process.env.PUBLIC_URL + "/products?genders=Women&page=1"}>
                {t('brands')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Women&brands=adidas&page=1"}>
                    adidas
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Women&brands=Asics&page=1"}>
                    Asics
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Women&brands=Hoka%20One%20One&page=1"}>
                    Hoka One One
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Women&brands=New%20Balance&page=1"}>
                    New Balance
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Women&brands=Nike&page=1"}>
                    Nike
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Women&brands=On%20Running&page=1"}>
                    On Running
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Women&brands=Puma&page=1"}>
                    Puma
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Women&brands=Saucony&page=1"}>
                    Saucony
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li className="menu-item-has-children">
          <a href={process.env.PUBLIC_URL + "/athletisme?page=1"}>
            {t('trackandfield')}
          </a>
          <ul className="sub-menu">
            <li className="menu-item-has-children">
              <a>
                {t('gender')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Men&shopType=athletisme&page=1"}>
                    {t('men')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Women&shopType=athletisme&page=1"}>
                    {t('women')}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
          <ul className="sub-menu">
            <li className="menu-item-has-children">
              <a href={process.env.PUBLIC_URL + "/products/shoes?shopType=athletisme&page=1"}>
                {t('shoes')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?category=Entrainements&shopType=athletisme&page=1"}>
                    {t('training')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?category=Compétitions&shopType=athletisme&page=1"}>
                    {t('competition')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?category=Claquettes&page=1"}>
                    {t('thongs')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?shopType=athletisme&page=1"}>
                    {t('allshoes')}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
          <ul className="sub-menu">
            <li className="menu-item-has-children">
              <a href={process.env.PUBLIC_URL + "/products/spikes?page=1"}>
                {t('spikes')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/spikes?category=Cross&page=1"}>
                    {t('cross')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/spikes?category=Demi-fond&page=1"}>
                    {t('middledistance')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/spikes?category=Sprint&page=1"}>
                    {t('sprint')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/spikes?category=Autres&page=1"}>
                    {t('others')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/spikes?page=1"}>
                    {t('allspikes')}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
          <ul className="sub-menu">
            <li className="menu-item-has-children">
              <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=athletisme&page=1"}>
                {t('apparel')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=athletisme&category=Brassières&page=1"}>
                    {t('bra')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=athletisme&category=Débardeurs&page=1"}>
                    {t('singlet')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=athletisme&category=Tee-shirts&page=1"}>
                    {t('teeshirt')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=athletisme&category=Vestes&page=1"}>
                    {t('hoodies')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=athletisme&category=Shorts&page=1"}>
                    {t('short')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=athletisme&category=Collants&page=1"}>
                    {t('longtight')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=athletisme&category=Equipe%20de%20France&page=1"}>
                    {t('frenchteam')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=athletisme"}>
                    {t('allproducts')}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
          <ul className="sub-menu">
            <li className="menu-item-has-children">
              <a href={process.env.PUBLIC_URL + "/products/accessories?page=1"}>
                {t('accessories')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?category=Bonnets&page=1"}>
                    {t('hat')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?category=Chaussettes&page=1"}>
                    {t('socks')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?shopType=athletisme&category=Gants&page=1"}>
                    {t('gloves')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/electronic?category=Montres%20GPS&page=1"}>
                    {t('gps')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/nutrition?page=1"}>
                    {t('food')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/electronic?page=1"}>
                    {t('electronic')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?category=Sac%20à%20dos&page=1"}>
                    {t('bag')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?page=1"}>
                    {t('allaccesories')}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li className="menu-item-has-children">
          <a href={process.env.PUBLIC_URL + "/running?page=1"}>
            {t('running')}
          </a>
          <ul className="sub-menu">
            <li className="menu-item-has-children">
              <a>
                {t('gender')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Men&shopType=running&page=1"}>
                    {t('men')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Women&shopType=running&page=1"}>
                    {t('women')}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
          <ul className="sub-menu">
            <li className="menu-item-has-children">
              <a href={process.env.PUBLIC_URL + "/products/shoes?shopType=running&page=1"}>
                {t('shoes')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?category=Neutre&shopType=running&page=1"}>
                    {t('neutral')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?category=Stabilité&shopType=running&page=1"}>
                    {t('stability')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?category=Pronateur&shopType=running&page=1"}>
                    {t('pronate')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?category=Entrainements&shopType=athletisme&page=1"}>
                    {t('training')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?category=Compétitions&shopType=athletisme&page=1"}>
                    {t('competition')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?category=Claquettes&page=1"}>
                    {t('thongs')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?shopType=running&page=1"}>
                    {t('allshoes')}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
          <ul className="sub-menu">
            <li className="menu-item-has-children">
              <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=running&page=1"}>
                {t('apparel')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=running&category=Brassières&page=1"}>
                    {t('bra')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=running&category=Débardeurs&page=1"}>
                    {t('singlet')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=running&category=Tee-shirts&page=1"}>
                    {t('teeshirt')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=running&category=Vestes&page=1"}>
                    {t('hoodies')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=running&category=Shorts&page=1"}>
                    {t('short')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=running&category=Collants&page=1"}>
                    {t('longtight')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=running&category=Equipe%20de%20France&page=1"}>
                    {t('frenchteam')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=running"}>
                    {t('allproducts')}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
          <ul className="sub-menu">
            <li className="menu-item-has-children">
              <a href={process.env.PUBLIC_URL + "/products/accessories?page=1"}>
                {t('accessories')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?category=Bonnets&page=1"}>
                    {t('hat')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?category=Chaussettes&page=1"}>
                    {t('socks')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?shopType=running&category=Gants&page=1"}>
                    {t('gloves')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/electronic?category=Montres%20GPS&page=1"}>
                    {t('gps')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/nutrition?page=1"}>
                    {t('food')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/electronic?page=1"}>
                    {t('electronic')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?category=Sac%20à%20dos&page=1"}>
                    {t('bag')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?page=1"}>
                    {t('allaccesories')}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li className="menu-item-has-children">
          <a href={process.env.PUBLIC_URL + "/trail?page=1"}>
            {t('trail')}
          </a>
          <ul className="sub-menu">
            <li className="menu-item-has-children">
              <a>
                {t('gender')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Men&shopType=trail&page=1"}>
                    {t('men')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products?genders=Women&shopType=trail&page=1"}>
                    {t('women')}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
          <ul className="sub-menu">
            <li className="menu-item-has-children">
              <a href={process.env.PUBLIC_URL + "/products/shoes?shopType=trail&page=1"}>
                {t('shoes')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?category=Trail%20court&shopType=trail&page=1"}>
                    {t('shorttrail')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?category=Trail%long&shopType=trail&page=1"}>
                    {t('longtrail')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?category=Claquettes&page=1"}>
                    {t('thongs')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/shoes?shopType=trail&page=1"}>
                    {t('allshoes')}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
          <ul className="sub-menu">
            <li className="menu-item-has-children">
              <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=trail&page=1"}>
                {t('apparel')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=trail&category=Brassières&page=1"}>
                    {t('bra')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=trail&category=Débardeurs&page=1"}>
                    {t('singlet')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=trail&category=Tee-shirts&page=1"}>
                    {t('teeshirt')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=trail&category=Vestes&page=1"}>
                    {t('hoodies')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=trail&category=Shorts&page=1"}>
                    {t('short')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=trail&category=Collants&page=1"}>
                    {t('longtight')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/apparel?shopType=trail"}>
                    {t('allproducts')}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
          <ul className="sub-menu">
            <li className="menu-item-has-children">
              <a href={process.env.PUBLIC_URL + "/products/accessories?page=1"}>
                {t('accessories')}
              </a>
              <ul className="sub-menu">
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?category=Bonnets&page=1"}>
                    {t('hat')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?category=Chaussettes&page=1"}>
                    {t('socks')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?shopType=trail&category=Gants&page=1"}>
                    {t('gloves')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/electronic?category=Montres%20GPS&page=1"}>
                    {t('gps')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/nutrition?page=1"}>
                    {t('food')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/electronic?page=1"}>
                    {t('electronic')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?category=Sac%20à%20dos&page=1"}>
                    {t('bag')}
                  </a>
                </li>
                <li>
                  <a href={process.env.PUBLIC_URL + "/products/accessories?page=1"}>
                    {t('allaccesories')}
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
        <li className="menu-item-has-children">
          <a href={process.env.PUBLIC_URL + "/products/accessories?page=1"}>
            {t('accessories')}
          </a>
          <ul className="sub-menu">
            <li>
              <a href={process.env.PUBLIC_URL + "/products/accessories?category=Bonnets&page=1"}>
                {t('hat')}
              </a>
              <a href={process.env.PUBLIC_URL + "/products/accessories?category=Chaussettes&page=1"}>
                {t('socks')}
              </a>
              <a href={process.env.PUBLIC_URL + "/products/accessories?category=Gants&page=1"}>
                {t('gloves')}
              </a>
              <a href={process.env.PUBLIC_URL + "/products/accessories?category=Lunettes%20de%20vitesse&page=1"}>
                {t('speedglasses')}
              </a>
              <a href={process.env.PUBLIC_URL + "/products/accessories?category=Sac%20à%20dos&page=1"}>
                {t('bag')}
              </a>
              <a href={process.env.PUBLIC_URL + "/products/accessories?page=1"}>
                {t('allaccesories')}
              </a>
            </li>
          </ul>
        </li>
        <li className="menu-item-has-children">
          <a href={process.env.PUBLIC_URL + "/products/electronic?page=1"}>
            {t('electronic')}
          </a>
          <ul className="sub-menu">
            <li>
              <a href={process.env.PUBLIC_URL + "/products/electronic?category=Capteur%20de%20puissance&page=1"}>
                {t('powermeter')}
              </a>
              <a href={process.env.PUBLIC_URL + "/products/electronic?category=Ceinture%20cardiaque&page=1"}>
                {t('hrsensor')}
              </a>
              <a href={process.env.PUBLIC_URL + "/products/electronic?category=Electrostimulation&page=1"}>
                {t('electrostimulation')}
              </a>
              <a href={process.env.PUBLIC_URL + "/products/electronic?category=Lampes%20frontales&page=1"}>
                {t('headlamps')}
              </a>
              <a href={process.env.PUBLIC_URL + "/products/electronic?category=Montres%20GPS&page=1"}>
                {t('gps')}
              </a>
              <a href={process.env.PUBLIC_URL + "/products/electronic?category=Pistolets%20de%20massage&page=1"}>
                {t('massagegun')}
              </a>
              <a href={process.env.PUBLIC_URL + "/products/electronic?category=Pressothérapie&page=1"}>
                {t('pressotherapy')}
              </a>
              <a href={process.env.PUBLIC_URL + "/products/electronic?page=1"}>
                {t('allelectronic')}
              </a>
            </li>
          </ul>
        </li>
        <li className="menu-item-has-children">
          <a href={process.env.PUBLIC_URL + "/products/nutrition?page=1"}>
            {t('food')}
          </a>
          <ul className="sub-menu">
            <li>
              <a href={process.env.PUBLIC_URL + "/products/nutrition?category=Barres%20énergétiques&page=1"}>
                {t('energybar')}
              </a>
              <a href={process.env.PUBLIC_URL + "/products/nutrition?category=Boissons%20énergétiques&page=1"}>
                {t('energydrinks')}
              </a>
              <a href={process.env.PUBLIC_URL + "/products/nutrition?category=Gels%20énergétiques&page=1"}>
                {t('energygels')}
              </a>
              <a href={process.env.PUBLIC_URL + "/products/nutrition?category=Packs&page=1"}>
                {t('packs')}
              </a>
              <a href={process.env.PUBLIC_URL + "/products/nutrition?page=1"}>
                {t('allfood')}
              </a>
            </li>
          </ul>
        </li>
        <li className="menu-item-has-children">
          <a href={process.env.PUBLIC_URL + "/products/vouchers"}>{t('vouchers')}</a>
        </li>
        {
          i18n.language == "fr" ?
              <li className="menu-item-has-children">
                <a href={process.env.PUBLIC_URL + "/blog"}>
                  {t('media')}
                </a>
                <ul className="sub-menu">
                  <li>
                    <a href={process.env.PUBLIC_URL + "/blog"}>
                      {t('blog')}
                    </a>
                    <a href={process.env.PUBLIC_URL + "/podcasts"}>
                      {t('podcasts')}
                    </a>
                  </li>
                </ul>
              </li>
              :
              null
        }

        <li className="menu-item-has-children">
          <a href="">
            {t('socialmedias')}
          </a>
          <ul className="sub-menu">
            <li>
              <a
                  href="https://www.instagram.com/temporunclub/"
                  target="_blank"
                  rel="noopener noreferrer"
              >
                Instagram
              </a>
            </li>
            <li>
              <a
                  href="https://www.facebook.com/temporunclub/"
                  target="_blank"
                  rel="noopener noreferrer"
              >
                Facebook
              </a>
            </li>
            <li>
              <a
                  href="https://www.linkedin.com/company/the-running-collective/"
                  target="_blank"
                  rel="noopener noreferrer"
              >
                LinkedIn
              </a>
            </li>
            <li>
              <a
                  href="https://vm.tiktok.com/ZMRvvqYeJ/"
                  target="_blank"
                  rel="noopener noreferrer"
              >
                Tiktok
              </a>
            </li>
            <li>
              <a
                  href="https://twitter.com/trc_run"
                  target="_blank"
                  rel="noopener noreferrer"
              >
                Twitter
              </a>
            </li>
            <li>
              <a
                  href="https://www.youtube.com/channel/UCv6qkHY7_c5fq6xZlZCi8Zg"
                  target="_blank"
                  rel="noopener noreferrer"
              >
                Youtube
              </a>
            </li>
          </ul>
        </li>
        <li className="menu-item-has-children">
          <a href={process.env.PUBLIC_URL + "/games"}>{t('games')}</a>
        </li>
        <li className="menu-item-has-children">
          <a href={process.env.PUBLIC_URL + "/pace"}>{t('pacecalculator')}</a>
        </li>
      </ul>
      {user ?
          <ul>
            <li>
              <hr/>
            </li>
            <li>
              <a href={process.env.PUBLIC_URL + "/my-account"}>
                {t('myaccount')}
              </a>
            </li>
            <li>
              <a href={process.env.PUBLIC_URL + "/logout"}>
                {t('logout')}
              </a>
            </li>
          </ul>

          :
          <ul>
            <li>
              <hr/>
            </li>
            <li>
              <a href={process.env.PUBLIC_URL + "/login-register"}>{t('login')}</a>
            </li>
          </ul>

      }
    </nav>
  );
};

MobileNavMenu.propTypes = {
  strings: PropTypes.object
};

export default multilanguage(MobileNavMenu);
